<template>
<div class="dps-item">
  <div
    v-on:click="product.selected = !product.selected"
    v-bind:class="[product.device, { 'dps-active': product.selected }]"
  >
    <div :class="productClass(product.name.toLowerCase())"></div>
  </div>
  {{product.name}}
  <div>
    <select v-model="selectedFormat" :disabled="!product.selected">
      <option v-bind:value="format" v-for="format in product.formats">{{format.size}}</option>
    </select>
  </div>
</div>
</template>

<script>

export default {

  name: 'product-item',

  props: {
    product: {
      type: Object,
      required: true
    },
    onSelectFormat: {
      type: Function,
      required: true
    }
  },

  data () {
    return {
      selectedFormat: this.product.formats[0]
    }
  },

  mounted: function () {
    this.onSelectFormat(this.product, this.selectedFormat)
  },

  watch: {
    selectedFormat: function (newValue, oldValue) {
      this.onSelectFormat(this.product, newValue)
    }
  },

  methods: {

    productClass: function (id) {
      let value = ['ad']
      value.push('ad-' + id)
      return value.join(' ')
    }

  }

}

</script>

<style>

.mobile {
  border: 1px solid #DDDDDD;
  border-top: 5px solid #dddddd;
  border-radius: 2px 2px 0 0;
  height: 40px;
  width: 30px;
  background: #fdfcf7;
  float: left;
  margin-right: 10px;
  transition: border-color .25s ease-in-out;
  cursor: pointer;
  box-shadow: 1px 1px 6px rgba(0,0,0,0.1);
}

.desktop {
  border: 1px solid #DDDDDD;
  border-top: 5px solid #dddddd;
  border-radius: 2px 2px 0 0;
  height: 40px;
  width: 50px;
  background: #fdfcf7;
  float: left;
  margin-right: 10px;
  transition: border-color .25s ease-in-out;
  cursor: pointer;
  box-shadow: 1px 1px 6px rgba(0,0,0,0.1);
}

.desktop:hover, .mobile:hover {
  border-color: #085387;
}

.ad {
  background-color: #085387;
  transition: background-color .25s ease-in-out;
}

.desktop.dps-active, .mobile.dps-active {
  border-color: #38b521;
  background: #f2fffa;
}

.desktop.dps-active > .ad, .mobile.dps-active > .ad {
  background: #38b521;
}

.ad-panorama {
  height: 10px;
  width: 80%;
  margin: 0 auto;
}

.ad-outsider {
  height: 30px;
  width: 10px;
  left: 40px;
  top: 5px;
  position: relative;
}

.ad-mpu {
  height: 20px;
  width: 30px;
  left: 10px;
  top: 10px;
  position: relative;
}

.ad-helsida {
  width: 95%;
  height: 95%;
  position: relative;
  top: 1px;
  margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/components/ProductItem.vue